
import React, { useEffect, useState } from 'react'
import styled  from 'styled-components'
import { toast } from 'react-toastify';
import BackLink from '../../components/BackLink'
import { Spin } from 'antd';
import { LoadingOutlined} from '@ant-design/icons'
import { bindInviterApi } from '../../apis';
export default function Invite() {
  
   const [code,setCode] =  useState('')
   const [spinning, setSpinning] = useState(false);
   const exchangeCard = async (code) => {
    setSpinning(true)
    let res =  await bindInviterApi({nodeId:code})
    // console.log(res.data)
    if(res.data.code === 0){
        setSpinning(false)
        toast.success('绑定成功')
    }else{
        setSpinning(false)
        toast.error(res.data.message)
    }
   }
  
  return (
    <Block className='w-[1000px] sm:w-full px-[117px] sm:px-[15px]'> 
        <div className='mt-[40px]'>
            <BackLink  to={-1}>返回</BackLink> 
        </div>
        <Spin
            spinning={spinning}
            indicator={
            <LoadingOutlined
                style={{
                fontSize: 24,
                }}
                percent='auto'
                fullscreen="true"
            />
         }>
            <Warpper className='w-[600px] sm:w-full py-[48px] px-[136px] sm:p-4'>
                <Title>邀请您的好友Node ID</Title>
                <Desc>(填写邀请您的好友Node ID，您和好友都可获得BFT奖励。)</Desc>
                    <Input  className='w-[328px] sm:w-full' value={code}  onChange={ (e) => setCode(e.target.value) } placeholder='请输入好友的Node ID'   />
                    <Button  className={`w-[328px] sm:w-full ${code == '' ?  'bg-[#E5E5EA] text-[#C7C7CC]': 'bg-[#0057FF] active:bg-[#347DFF] text-white'} `} disabled={!code} onClick={ () => {
                        if( code === '' ) {
                            return false
                        }
                        exchangeCard(code);
                    }}>确认</Button>
            </Warpper>
        </Spin>
            
       
    </Block>
  )
}

const Block = styled.div`
    margin:0 auto;
    text-align:left;
`
const Warpper = styled.div`
    background: #FFFFFF;
    border-radius: 16px;
    margin: 0 auto;
    margin-bottom:56px;
    margin-top:48px;
`
const Title = styled.div`
    width: 100%;
    height: 28px;
    font-size: 18px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #1A1A1A;
    line-height: 28px;
`
const  Button = styled.button`
    height: 40px;
   
    border-radius: 4px;
    
    outline:none;
    border:none;
    cursor: pointer;
    display:block;
    margin:0 auto;
`
const Input = styled.input`
    height: 40px;
    background: #EFEFF4;
    border-radius: 4px;
    padding:10px;
    outline:none;
    border-color:transparent;
    margin:32px 0;
`
const Desc = styled.div`
    height: 16px;
    font-size: 12px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    color: #B3B3B3;
    line-height: 16px;
    margin-top:6px;
`